import { ErrorHandler, Inject, Injectable } from '@angular/core';
import { ErrorHandlerService } from 'hdi-components';

/**
 * This file defines a custom GlobalErrorHandler class that implements Angular's ErrorHandler interface.
 * It acts as a global catch-all for uncaught errors in the Angular application.
 * The handler delegates the actual error logging or processing to a shared ErrorHandlerService
 * defined in the hdi-components library.
 * This approach ensures all uncaught errors are routed through a centralized service,
 * making it easier to manage logging, monitoring, or error transformation logic.
 */

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  constructor(
    @Inject(ErrorHandlerService)
    private errorHandlerService: ErrorHandlerService
  ) {}

  handleError(error: Error): void {
    this.errorHandlerService.handleError(
      error instanceof Error ? error : new Error(error as string),
      'GlobalError'
    );
  }
}
